import script from "./ManutOsExclusaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutOsExclusaoPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutOsExclusaoPage.vue?vue&type=style&index=0&id=03941338&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03941338"]])

export default __exports__